const IDEAL_ASSETS_BASE = "https://profile.ideal.nl/static/ideal-assets";

export const bankIcons: Record<string, { uri: string }> = {
  ABNANL2A: { uri: `${IDEAL_ASSETS_BASE}/ABNANL2A.svg` },
  ASNBNL21: { uri: `${IDEAL_ASSETS_BASE}/ASNBNL21.svg` },
  INGBNL2A: { uri: `${IDEAL_ASSETS_BASE}/INGBNL2A.svg` },
  RABONL2U: { uri: `${IDEAL_ASSETS_BASE}/RABONL2U.svg` },
  RBRBNL21: { uri: `${IDEAL_ASSETS_BASE}/RBRBNL21.svg` },
  SNSBNL2A: { uri: `${IDEAL_ASSETS_BASE}/SNSBNL2A.svg` },
  TRIONL2U: { uri: `${IDEAL_ASSETS_BASE}/TRIONL2U.svg` },
};
